import {Environment} from "platform/enum/Environment";

enum StorageKey {

    AccountType = "__act",
    Accounts = "__acts",
    UserId = "__usdi",
    Environment = "__env",
    PortfolioSort = "__ps",
    AlertsSort = "__as",
    SymbolsSort = "__ss",
    SignalsSort = "__siso",
    SignalsSettings = "__sis",
    ShowChartDesktop = "__sciqdl",
    ShowChartMobile = "__sciqml",
    CompactListView = "__mclvl",
    ChartMobileY = "__cmyl",
    ChartMobileAcY = "__cmacyl",
    ChartMobileArY = "__cmaryl",
    PopupSound = "__pps",
    Emails = "__pem",
    PushNotifications = "__ppn",
    PhoneCalls = "__ppc",
    SMS = "__psms",
    AcademyWatchedVideos = "__awv",
    AcademyPassedWalkThroughS = "__apwt",
    SelectedContinents = "_scont",
    SelectedBroker = "__sb"
}

namespace StorageKey {

    export function hasKey(key: string): boolean {
        for (const sk in StorageKey) {
            if (StorageKey[sk] === key) {
                return true;
            }
        }
        return false;
    }

    export function UsernameKey(brandId: number, environment: Environment): string {
        return `__usn_${brandId}_${environment}`;
    }

    export function PasswordKey(brandId: number, environment: Environment): string {
        return `__#%$*()_${brandId}_${environment}`;
    }
}

export {
    StorageKey
};
